import React from 'react'
import { SmallMarbleRating } from './SmallMarbleRating'
import RatingDetailsTooltip from './RatingDetailsTooltip/RatingDetailsTooltip'

interface IProps {
  topicId: number
  rating: number
  numberRated: number
}

export const TopicSmallMarbleRating = ({
  topicId,
  rating,
  numberRated
}: IProps) => (
  <SmallMarbleRating rating={rating} numberRated={numberRated}>
    <RatingDetailsTooltip topicId={topicId} />
  </SmallMarbleRating>
)
